module.exports = __webpack_public_path__ + "img/download.4071be1f.svg";